import { Injectable } from '@angular/core';
import { CONFIG } from '../../shared/config';
import { GeneralSearchParms, HttpGeneralService, StockModuleSettingsParms } from '../../shared';

import { GenSchReservedSlots } from '../order-reception/order-reception/order-reception.service';
import { Time } from '@angular/common';
let orderingUrl = CONFIG.baseUrls.ordering;
let stockTransUrl = CONFIG.baseUrls.StockTrans;
let inpatientinqueryUrl = CONFIG.baseUrls.inpatientlist;

export interface regPatMedicalSteps {
  visitSerial?: number,
  serviceId?: number,
  empId?: number,
  statusCode?: number,
  regPatServiceWorkFlowSerial?: number,
  previouseWorkFlowSerial?: number,
  resourceId?: number,
  expectedDate?: Date,
  regDate?: Date,
  deviceNameAr?: string;
  state?: number,
  deleteStatus?: number,
  priServiceStpMedicalStepId?: number,
  regPatServiceSerial?: number,
  serial?: number,
  stepStatus?: number,
  notes?: string,
  sessionStart?: Date,
  sessionEnd?: Date,
  timeStart?: any,
  timeEnd?: any,
  scheduledResourceCode?: number;
  entityType?: number;
  dataStatus?: number;
  cancelReasonCode?: number;
  cancelNotes?: string
  selected?: any;
  regPatMedicalStepsSerial?: number;
  needUpdate?: number
  scheduleDocID?: number;
  scheduleDeviceID?: number;
  scheduleVplaceID?: number;
  commissionPercent?: number;
  pricePercent?: number;
  expectedEndDate?: Date;
  stepNumber?: number;
  newDermaNoteSerial?: number;
  sendReservMessageFlag?: number;
  sentMessageContent?: string;
  expectedDateFormated?: any
}

export interface ServiceScheduling {
  serial?: number;
  docCode?: number;
  patCode?: number;
  serviceType?: number;
  ngbFromDate?: Date;
  ngbToDate?: Date;
  expectedStartTime?: Date;
  expectedEndTime?: Date;
  scheduledResourceCode?: number;
  secondResourceId?: number; //الجهاز
  vPlaceId?: number; // المكان
  offset?: number;
  pageSize?: number;
  deviceCode?: number;
  resourceId?: number;//doctor sayed
  resourceType?: number;
  serviceId?: number;
  entityType?: number;
  mode?: number;
}
export interface ReservedSlotWithDeviceSteps {

  regPatMedicalSteps?: regPatMedicalSteps[],
  GenSchReservedSlots?: GenSchReservedSlots[]
}

@Injectable({
  providedIn: 'root'
})
export class NursingService {

  constructor(private httpGeneralService: HttpGeneralService) { }

  getPatientWithSerivces(orderSearch: any) {
    return this.httpGeneralService.post(orderSearch, `${orderingUrl}/getPatientWithSerivces`);
  }

  getPatientMonthlySch(orderSearch: any) {
    return this.httpGeneralService.post(orderSearch, `${orderingUrl}/GetPatientMonthlySch`);
  }
  getPatientWithSerivcesWithMidecalSteps(orderSearch: any) {
    return this.httpGeneralService.post(orderSearch, `${orderingUrl}/getPatientWithSerivcesWithMidecalSteps`);
  }



  getModuleSettings(parms: StockModuleSettingsParms) {
    return this.httpGeneralService.add(parms, `${stockTransUrl}/GetStockModuleSettings`);
  }
  addRegPatMedicalSteps(regPatMedicalSteps: regPatMedicalSteps[]) {
    return this.httpGeneralService.addCollection(regPatMedicalSteps, `${orderingUrl}/PostRegPatMedicalSteps`)
  }
  cancelRegPatMedicalSteps(regPatMedicalSteps: regPatMedicalSteps[]) {
    return this.httpGeneralService.add(regPatMedicalSteps, `${orderingUrl}/CancelRegPatMedicalSteps`)
  }


  addReservedSlotWithDeviceSteps(ReservedSlotWithDeviceSteps: ReservedSlotWithDeviceSteps) {
    return this.httpGeneralService.add(ReservedSlotWithDeviceSteps, `${orderingUrl}/PostReservedSlotWithDeviceSteps`)
  }
  getUpdateServiceScheduling(moduleParms: ServiceScheduling) {
    return this.httpGeneralService.add(moduleParms, `${inpatientinqueryUrl}/getUpdateServiceScheduling`);
  }
  updateSchedulingService(serial: number, ServiceScheduling: ServiceScheduling) {
    return this.httpGeneralService.update(serial, ServiceScheduling, `${inpatientinqueryUrl}/updateSchedulingService`);
  }

  updateSchedulingSession(serial: number, ServiceScheduling: ServiceScheduling) {
    return this.httpGeneralService.update(serial, ServiceScheduling, `${inpatientinqueryUrl}/updateSchedulingSession`);
  }


  getStockModuleSettings(parms: StockModuleSettingsParms) {
    return this.httpGeneralService.add(parms, `${stockTransUrl}/GetStockModuleSettings`);
  }
}

